// extracted by mini-css-extract-plugin
export var inverted = "title-module--inverted--c6e42";
export var wrapper = "title-module--wrapper--32e1e";